import React from "react";
import "./Message.css";
import { makeStyles } from "@material-ui/core/styles";
import male_patient from "../../../../images/male_chat_head.jpg";
import female_patient from "../../../../images/female_chat_head.jpg";
import parse from "html-react-parser";
import { v4 as uuidv4 } from "uuid";
import { saveHistoryTaking } from "../../../../redux/dispatchers";
import { renderReply } from "../..";
import { store } from "../../../../redux/store";

const useStyles = makeStyles((theme) => ({
  time: {
    fontSize: 10,
  },
  profile: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    margin: theme.spacing(0, 0.2, 0, 0),
  },
  suggestion: {
    color: "#00008B",
    textDecoration: "underline",
    cursor: "pointer",
  },
}));

export default function Message({ message }) {
  const classes = useStyles();
  const gender = store.getState().gameStates.case.gender;
  const renderContent = () => {
    if (Array.isArray(message.content)) {
      const currentQuestions = message.content.slice(0, 3);
      const nextQuestions = message.content.slice(3);

      if (!currentQuestions.length) {
        return <p>Sorry I don't understand what you were asking.</p>;
      }
      return (
        <>
          <p>Are you asking:</p>
          {currentQuestions.map((record) => {
            return (
              <p
                key={record.id}
                className={classes.suggestion}
                onClick={() => {
                  saveHistoryTaking({
                    id: uuidv4(),
                    isCurrentUser: true,
                    content: record.question,
                    timestamp: +new Date(),
                  });
                  renderReply(record);
                }}
              >
                {record.question}
              </p>
            );
          })}
          <p
            className={classes.suggestion}
            onClick={() => {
              saveHistoryTaking({
                id: uuidv4(),
                isCurrentUser: false,
                content: nextQuestions,
                timestamp: +new Date(),
              });
            }}
          >
            None of above
          </p>
        </>
      );
    }

    return parse(message.content);
  };

  const renderMessage = () => {
    if (message.isCurrentUser) {
      return (
        <div className="messageContainer justifyEnd">
          <div className="messageBox backgroundBlue" id="user">
            <div className="messageText colorWhite">
              {parse(message.content)}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="messageContainer justifyStart">
        <img
          src={gender === "male" ? male_patient : female_patient}
          className={classes.profile}
          alt="Patient Profile"
        />
        <div className="messageBox backgroundLight" id="patient">
          <div className="messageText colorDark">
            {renderContent(message.content)}
          </div>
        </div>
      </div>
    );
  };

  return renderMessage();
}
